import store from "../store";

export default function(reason) {
  const error = reason.response;
  console.log("Error Handler:", reason);
  if (error) {
    switch (error.status) {
      case 401:
        // store.dispatch("auth/LOGOUT");
        store.dispatch("notification/SHOW_ERROR", error.data);
        break;
      default:
        store.dispatch("notification/SHOW_ERROR", error.data);
    }
  } else {
    store.dispatch("notification/SHOW_ERROR", reason);
  }
}
